import React from "react";
import { Controller, UseFormReturn } from "react-hook-form";
import { PersonalizationValue } from "@dots-projects/types";
import { DiscordTextEditor } from "../TextEditor/DiscordTextEditor";

type Props = {
  form: UseFormReturn<any>;
  htmlField: string;
  markdownField: string;
  insertVariables?: PersonalizationValue[];
  defaultValue?: string;
  readOnly?: boolean;
};

/**
 * Discord Text editor for Trigger Editor
 * @param props
 * @constructor
 */
function TriggerEditorDiscordTextEditor(props: Props) {
  const {
    form,
    htmlField,
    markdownField,
    insertVariables,
    defaultValue,
    readOnly,
  } = props;

  const { control, setValue } = form;
  return (
    <Controller
      control={control}
      name={htmlField}
      render={({ field }) => (
        <DiscordTextEditor
          onChange={(response) => {
            field.onChange(response.html);
            // We need to save the markdown message from DiscordTextEditor, so we set the value manually
            setValue(markdownField, response.text);
          }}
          value={{
            html: field.value || defaultValue,
          }}
          personalizationValues={insertVariables}
          readOnly={readOnly}
          disablePersonalTokens
        />
      )}
    />
  );
}

export default TriggerEditorDiscordTextEditor;
